export const getBrowserLang = function() {
    let browserLang = navigator.language
      ? navigator.language
      : navigator.browserLanguage;
    let defaultBrowserLang = "";
    if (browserLang.substr(0, 2).toLowerCase() == 'en') {
      defaultBrowserLang = "en_GB";
    } else if(browserLang.substr(0, 2).toLowerCase() == 'zh'){
        if(browserLang.toLowerCase() == 'zh-cn') {
            defaultBrowserLang = "zh_CN";
        }else {
            defaultBrowserLang = "zh_HK";
        }
    }
    return defaultBrowserLang;
};